import { mediaUrls } from 'globalconfig/constants/mediaUrls';

/**
 * Rotating left-panel marketing slides for Spireon FleetLocate login.
 * Images: packages/assets/media/fm/spireon/SpireonNew/FleetLocate_LoginBanners*
 * @typedef {{ picSource: string, title: string, content: string, getResourceLink: string }} FleetMarketingSlide
 */

/** @type {FleetMarketingSlide[]} */
const spireonFleetMarketingSlides = [
  {
    picSource: mediaUrls.fleetLocateSlideFl360,
    title: 'Simplify Compliance with ELD & DVIR',
    content: "Activate FL Compliance with Spireon’s FL360 to comply with the ELD Mandate, Hours of Service (HOS), Driver Vehicle Inspection Reporting (DVIR), and the International Fuel Tax Agreement (IFTA). Stay compliant, track your fleet, and monitor driver behavior from one online portal.",
    getResourceLink: 'https://www.spireon.com/solutions/fleet-managers/simplify-compliance-with-ELD-and-DVIR/',
  },
  {
    picSource: mediaUrls.fleetLocateSlideBanner1,
    title: 'Vehicle & Driver Intelligence for Any Vehicle Type',
    content: "Our FL360 is a modular GPS tracking device that supports light, medium, and heavy-duty vehicles.",
    getResourceLink: 'https://www.spireon.com/products/fleetlocate-for-fleet-managers/fl-360/',
  },
  {
    picSource: mediaUrls.fleetLocateSlideFlex2,
    title: 'Trailer and Asset Tracking',
    content: "Increase profitability and protect your assets from misuse or theft, with Flex 2. This covert GPS tracking device combines with intelligent cloud software, to give you actionable insights so you can make smarter business decisions faster.",
    getResourceLink: 'https://www.spireon.com/products/fleetlocate-for-fleet-managers/fl-flex-2/',
  },
  {
    picSource: mediaUrls.fleetLocateSlideFlexBattery,
    title: 'The New Flex Battery Tracker Type',
    content: "The Flex Battery Tracker sets a new standard with increased durability, extended battery life, and advanced theft prevention measures for unpowered assets such as trailers, equipment, containers, and more.",
    getResourceLink: 'https://www.spireon.com/flex-battery-tracker/',
  },
  {
    picSource: mediaUrls.fleetLocateSlideCamCoach,
    title: 'AI Dashcam for Fleets',
    content:
      'CamCoach is designed to coach your drivers on the go. Get access to video recordings from anywhere. A detailed view of distracted driving events are also available so you can reduce liability risk, encourage safe driving, reduce insurance premiums, and reduce costs of claims.',
    getResourceLink: 'https://www.spireon.com/products/fleetlocate-for-fleet-managers/camcoach/',
    imageAlt: 'FleetLocate CamCoach banner',
  },
];

/**
 * @param {FleetMarketingSlide[]} slides
 * @returns {FleetMarketingSlide}
 */
export const pickRandomSlide = (slides = spireonFleetMarketingSlides) => {
  if (!slides.length) {
    return { picSource: '', title: '', content: '', getResourceLink: '' };
  }
  const index = Math.floor(Math.random() * slides.length);
  return slides[index];
};

export default spireonFleetMarketingSlides;
